import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getPathname = createSelector(
  ({ router }: RootState) => router.path,
  (s) => s,
);
export const getHost = ({ host = '' }) => host;
export const getBaseUrl = createSelector(
  getHost,
  getPathname,
  (host, pathname) => `https://${host}${pathname}`,
);

export const getHostname = createSelector(getHost, (host) => host?.replace(/:[0-9]+/, ''));

export const getStorePathname = createSelector(
  getPathname,
  (p) => p?.match(/\/shop\/([^\\/]*)/)?.[1] || null,
);
